import styled from "styled-components";

export const Container = styled.div`
  padding: 0 30px 30px 30px;

  & .input-wrapper {
    margin: 10px 0px;
  }
`;
